import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import { FoldersReducerType } from '../foldersState.types';
import {
  FolderDecision,
  FolderDecisionAnnotation,
} from '../../page/folders.types';

export const loadDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      decisions: {
        ...state.folders[folderKey].decisions,
        loading: true,
      },
    },
  },
});

export const errorDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
  error: ThrownType,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      decisions: {
        decisions: [],
        loading: false,
        error: error.response,
      },
    },
  },
});

export const getDecisionsState = (
  state: FoldersReducerType,
  folderKey: string,
  decisions: FolderDecision[],
  size?: number,
) => {
  const uniqDecisions = uniqBy(
    [
      ...get(state.folders[folderKey], ['decisions', 'decisions'], []),
      ...decisions,
    ],
    'docId',
  );
  const currentIndex = uniqDecisions.length;
  return {
    ...state,
    folders: {
      ...state.folders,
      [folderKey]: {
        ...state.folders[folderKey],
        decisions: {
          loading: false,
          decisions: uniqBy(
            [
              ...get(state.folders[folderKey], ['decisions', 'decisions'], []),
              ...decisions,
            ],
            'docId',
          ),
          hasMore: decisions.length === size,
          currentIndex,
        },
      },
    },
  };
};

export const loadAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        ...state.folders[folderKey].annotations,
        loading: true,
      },
    },
  },
});

export const errorAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
  error: ThrownType,
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        annotations: [],
        loading: false,
        error: error.response,
      },
    },
  },
});

export const getAnnotationsState = (
  state: FoldersReducerType,
  folderKey: string,
  annotations: FolderDecisionAnnotation[],
) => ({
  ...state,
  folders: {
    ...state.folders,
    [folderKey]: {
      ...state.folders[folderKey],
      annotations: {
        annotations,
        loading: false,
      },
    },
  },
});
